<template>
  <div class="wrapper" id="partners-page">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>
    <div id="main-panel2" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-65 md-small-size-85 mx-auto md-alignment-top-center"
          >
            <h3>
              <strong>REGULAMIN ŚWIADCZENIA USŁUG DROGĄ ELEKTRONICZNĄ </strong>
              <br />
              <strong>- INFOFORUM I APLIKACJI MOBILNEJ INFOFORUM</strong>
            </h3>
            <p>Realizując postanowienia:</p>
            <ol>
              <li>
                ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą
                elektroniczną (Dz.U. z 2024 r. poz. 1513),
              </li>
              <li>
                Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z
                27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku
                z przetwarzaniem danych osobowych i w sprawie swobodnego
                przepływu takich danych oraz uchylenia dyrektywy 95/46/WE
                (Dz.Urz.UE.L Nr 119, str. 1), dalej: RODO,
              </li>
              <li>
                ustawy z dnia 12 lipca 2024 r. prawo komunikacji elektronicznej
                (Dz.U. z 2024 r. poz. 1222),
              </li>
            </ol>
            <p>
              <strong>Fundacja Instytut Studiów Wschodnich</strong> z siedzibą w
              Warszawie, ul. Solec 85, 00-382 Warszawa, KRS 0000010303; NIP
              5211001909; REGON 01040240000000 zwaną dalej
              "<strong>Usługodawcą</strong>", wprowadza niniejszy Regulamin.
            </p>
            <h5>
              <strong>Rozdział 1 - Postanowienia ogólne</strong>
            </h5>
            <ol>
              <li>
                <strong>Definicje:</strong>
                <ul>
                  <li>
                    <strong>Ustawa </strong>- Ustawa z dnia 12 lipca 2024
                    r.prawo komunikacji elektronicznej
                  </li>
                  <li>
                    <strong>Usługi świadczone drogą elektroniczną</strong> -
                    usługi świadczone bez jednoczesnej obecności stron, za
                    pośrednictwem systemów teleinformatycznych
                  </li>
                  <li>
                    <strong>Środki komunikacji elektronicznej</strong> -
                    urządzenia i oprogramowanie służące do transmisji danych
                  </li>
                  <li>
                    <strong>Usługodawca</strong> - Fundacja Instytut Studiów
                    Wschodnich z siedzibą w Warszawie, ul. Solec 85, 00-382
                    Warszawa, NIP:521 100 1909; email:
                    <a href="mailto:mailto:infoforum@isw.org.pl"
                      >infoforum@isw.org.pl</a
                    >
                  </li>
                  <li>
                    <strong>Usługobiorca </strong>lub
                    <strong> Użytkownik </strong> - każdy, kto korzysta z usług
                    Usługodawcy
                  </li>
                  <li>
                    <strong>Serwis INFOFORUM lub Serwis</strong> - serwis
                    internetowy udostępniany przez Usługodawcę zarejestrowanym
                    uczestnikom Wydarzeń umożliwiający m.in. kontakt z innymi
                    uczestnikami, zapisanie się na wydarzenia rekreacyjne,
                    sprawdzenie listy partnerów Wydarzenia, poznanie plan sesji
                    plenarnych i paneli dyskusyjnych, informacje o wydarzeniach
                    kulturalnych i uroczystych galach
                  </li>
                  <li>
                    <strong>Forum Ekonomiczne w Karpaczu</strong> lub
                    <strong>FE</strong> - wydarzenie organizowane przez
                    Usługodawcę, wymagające rejestracji;
                  </li>
                  <li>
                    <strong>Europejski Kongres Samorządów</strong> lub
                    <strong>EKS</strong> - wydarzenie organizowane przez
                    Usługodawcę, wymagające rejestracji
                  </li>
                  <li>
                    <strong>Wydarzenia </strong>- Forum Ekonomiczne w Karpaczu
                    lub Europejski Kongres Samorządów lub inne wydarzenia
                    organizowane przez Usługodawcę
                  </li>
                  <li>
                    <strong>Konto</strong> - indywidualne konto użytkownika
                  </li>
                  <li>
                    <strong>Newsletter</strong> - cykliczna, zamówiona
                    informacja handlowa o wydarzeniach Usługodawcy
                  </li>
                  <li>
                    <strong>Zamówiona informacja handlowa</strong> - informacje
                    wysyłane na adres e-mail za zgodą Usługobiorcy
                  </li>
                  <li>
                    <strong>Aplikacja mobilna Forum Ekonomiczne</strong> -
                    opcjonalne narzędzie mobilne do zainstalowania na
                    urządzeniach przenośnych
                  </li>
                  <li><strong>Regulamin</strong> - niniejszy dokument.</li>
                </ul>
              </li>
            </ol>
            <h5>
              <strong>Rozdział 2 - Rodzaje i zakres usług</strong>
            </h5>
            <ol>
              <li>
                Usługi świadczone drogą elektroniczną:
                <ol>
                  <li>
                    Konto - konto Użytkowania umożliwiające dostęp do Serwisu
                    INFOFORUM
                  </li>
                  <li>
                    INFOFORUM - prywatny serwis internetowy dla zarejestrowanych
                    uczestników Wydarzeń
                  </li>
                  <li>
                    Aplikacja mobilna - opcjonalne narzędzie mobilne do
                    zainstalowania na urządzeniach przenośnych umożliwiające
                    dostęp do INFOFORUM
                  </li>
                </ol>
              </li>
              <li>
                Usługi mogą być też świadczone na podstawie odrębnych umów.
              </li>
            </ol>
            <h5>
              <strong
                >Rozdział 3 - Dostęp do INFOFORUM i Aplikacji Mobilnej</strong
              >
            </h5>
            <ol>
              <li>
                Dostęp do serwisu INFOFORUM przekazywany jest przez Usługodawcę
                Użytkownikowi, który dokonał rejestracji oraz opłacił swój
                udział w FE w konkretnym roku organizacji Wydarzenia.
                Usługodawca wysyła na adres e-mail Użytkownika podany w
                formularzu rejestracyjnym login i hasło z dostępem do serwisu
                informacyjnego Forum (INFOFORUM). Serwis ten dostępny jest tylko
                dla Zarejestrowanych Uczestników Forum posiadających status
                "Gość". Wszelkie pytania dotyczące INFOFORUM należy kierować na
                adres: infoforum@isw.org.pl
              </li>
              <li>
                Konto jest indywidualne i niezbywalne. Użytkownik musi
                zabezpieczyć dane dostępowe.
              </li>
              <li>
                Konto nie może być przekazane osobie trzeciej bez pisemnej zgody
                Usługodawcy.
              </li>
              <li>
                Udostępnienie danych osobom trzecim skutkować może pełną
                odpowiedzialnością Usługobiorcy za takie działania.
              </li>
              <li>
                W celu skorzystania z Aplikacji należy pobrać ją i zainstalować
                na swoim urządzeniu mobilnym.
              </li>
              <li>
                Aplikację można pobrać za pośrednictwem AppStore (dla urządzeń z
                systemem iOS) oraz Google Play (dla urządzeń z systemem
                Android).
              </li>
              <li>Pobranie aplikacji jest nieodpłatne.</li>
              <li>
                Przed pobraniem Aplikacji Użytkownik ma możliwość zapoznać się z
                Regulaminem, do którego link znajduje się w opisie Aplikacji.
                Regulamin można bezpłatnie pobrać i zapisać na swoim urządzeniu.
              </li>
              <li>
                Instalacja Aplikacji następuje po jej pobraniu na urządzenie
                mobilne Użytkownika.
              </li>
              <li>
                Nieodpłatnie udostępniamy Użytkownikowi Regulamin w sposób,
                który umożliwia pozyskanie, odtwarzanie i utrwalenie treści
                Regulaminu.
              </li>
              <li>
                Użytkownik powinien zapoznać się z treścią Regulaminu oraz
                Polityką Prywatności przed rejestracją Aplikacji. Jeżeli
                Użytkownik nie akceptuje ww. regulaminów, nie powinien korzystać
                z Aplikacji.
              </li>
              <li>
                Usługodawca będzie informował Użytkowników o planowanych Pracach
                Serwisowych e-mailem lub poprzez opublikowanie odpowiedniego
                komunikatu w Aplikacji.
              </li>
            </ol>
            <h5>
              <strong>Rozdział 4 - Wypowiedzenie usługi Konta</strong>
            </h5>
            <ol>
              <li>
                Usługobiorca może wypowiedzieć umowę prowadzenia Konta w każdej
                chwili ze skutkiem natychmiastowym, wysyłając oświadczenie o
                wypowiedzeniu na adres e-mail Usługodawcy
                <a href="mailto:infoforum@isw.org.pl">infoforum@isw.org.pl</a>.
                Wypowiedzenie staje się skuteczne z chwilą otrzymania przez
                Usługodawcę.
              </li>
              <li>
                Usługodawca może wypowiedzieć umowę prowadzenia Konta również w
                każdej chwili, ze skutkiem natychmiastowym, w przypadku rażącego
                lub zawinionego naruszenia przez właściciela Konta postanowień
                Regulaminu lub zaistnienia innej uzasadnionej przyczyny, która
                uniemożliwia dalsze świadczenie usługi.
              </li>
              <li>
                Konto zostanie usunięte po otrzymaniu żądania wypowiedzenia -
                nie później niż w ciągu miesiąca od jego otrzymania.
              </li>
              <li>
                Dostęp do Konta zostanie usunięty przez Usługodawcę w ciągu 30
                dni od dnia zakończenia Wydarzenia.
              </li>
            </ol>
            <h5>
              <strong
                >Rozdział 5 - Zasady techniczne korzystania z Serwisu</strong
              >
            </h5>
            <ol>
              <li>
                Usługodawca może przesyłać techniczne lub proceduralne
                komunikaty - nie są one informacjami handlowymi.
              </li>
              <li>
                Usługodawca może prowadzić prace konserwacyjne, powodujące
                czasowe utrudnienia w działaniu Serwisu.
              </li>
              <li>
                W celu skorzystania z Usługi Użytkownik oprócz Konta musi
                posiadać: komputer lub inne urządzenie przetwarzające dane typu
                tablet, smartphone itp., dostęp do sieci Internet, przeglądarkę
                internetową (Firefox 52.0 lub wersja wyższa, Chrome 49.0 lub
                wersja wyższa, Chrome Mobile 51.0 lub wersja wyższa, Microsoft
                Internet Explorer 11.0 lub wersja wyższa, Opera 47.0 lub wersja
                wyższa, WebKit Mobile 4.0 lub wersja wyższa) oraz ewentualnie
                oprogramowanie do odtwarzania plików w formacie.pdf. W przypadku
                jeśli w ramach Treści Serwisu Usługodawca zaproponuje dodatkowe
                produkty wymagające innych aplikacji Użytkownik zostanie o tym
                powiadomiony w stosownym komunikacie. Minimalne wymagania
                techniczne:
                <ol>
                  <li>
                    komputer/laptop/urządzenie z przeglądarką (Chrome &ge; 51,
                    Edge &ge; 15, Safari &ge; 10, Firefox &ge; 54, Opera &ge;
                    38),
                  </li>
                  <li>prędkość Internetu: min. 20 Mb/s.</li>
                </ol>
              </li>
              <li>
                Usługodawca może aktualizować wymagania techniczne - nie stanowi
                to zmiany Regulaminu.
              </li>
              <li>Koszty połączeń (Internet, telefon) ponosi Usługobiorca.</li>
              <li>
                Usługodawca nie szkoli Użytkowników z obsługi Serwisu - należy
                zapoznać się z jego zasadami samodzielnie.
              </li>
              <li>
                Użytkownikowi nie wolno (osobiście ani we współpracy z inną
                osobą) bezpośrednio, pośrednio, w sposób automatyczny lub inny,
                uzyskiwać dostępu do naszych Usług, wykorzystywać ich, kopiować,
                adaptować, modyfikować, tworzyć na ich podstawie dzieł
                pochodnych, dystrybuować, udzielać na nie licencji, sublicencji,
                przenosić, wyświetlać, wykonywać ani w inny sposób wykorzystywać
                Usług w sposób niedopuszczalny lub nieuprawniony bądź w sposób
                stanowiący dla nas obciążenie, szkodzący nam, Usługom
                Usługodawcy, systemom, naszym użytkownikom lub innym osobom, w
                tym użytkownikowi nie wolno bezpośrednio ani w sposób
                zautomatyzowany:
              </li>
              <li>
                dokonywać inżynierii odwrotnej naszych Usług, zmieniać ich,
                modyfikować, tworzyć na ich podstawie dzieł pochodnych,
                dekompilować ich, ani wyodrębniać z nich kodu
              </li>
              <li>
                naruszać bezpieczeństwa, poufności, dostępności ani działania
                Usług
              </li>
              <li>
                przesyłać, przechowywać ani przekazywać wirusów lub innego
                szkodliwego kodu komputerowego za pośrednictwem naszych Usług
                lub do nich
              </li>
              <li>
                uzyskiwać lub próbować uzyskać nieautoryzowany dostęp do Usług
                lub systemów
              </li>
              <li>
                tworzyć kont Usług w sposób nieuprawniony lub zautomatyzowany
              </li>
              <li>
                gromadzić informacji użytkowników lub na ich temat w sposób
                niedopuszczalny lub nieuprawniony
              </li>
              <li>
                sprzedawać, odsprzedawać, wynajmować lub pobierać opłat za nasze
                Usługi lub dane pozyskane z Usług w sposób nieuprawniony
              </li>
              <li>
                dystrybuować lub udostępniać Usług w sieci, gdzie można z nich
                korzystać na wielu urządzeniach jednocześnie, z wyjątkiem
                sposobu uprawnionego poprzez narzędzia, które wyraźnie
                udostępniamy za pośrednictwem Usług
              </li>
              <li>
                tworzyć oprogramowania bądź interfejsów API działających
                zasadniczo tak samo jak Usługi ani oferować ich do wykorzystania
                przez osoby trzecie w sposób nieuprawniony.
              </li>
            </ol>
            <h5>
              <strong
                >Rozdział 6 - Warunki świadczenia usług drogą
                elektroniczną</strong
              >
            </h5>
            <ol>
              <li>
                Usługodawca świadczy usługi na rzecz Usługobiorcy w zakresie i
                na warunkach określonych w Regulaminie lub indywidualnej ofercie
                (jeśli została złożona i przyjęta).
              </li>
              <li>
                Usługobiorca zobowiązuje się do przestrzegania niniejszego
                Regulaminu.
              </li>
              <li>
                Usługobiorca musi korzystać z usług i strony internetowej
                zgodnie z prawem oraz z poszanowaniem dóbr osobistych, praw
                autorskich i własności intelektualnej Usługodawcy oraz osób
                trzecich.
              </li>
              <li>Usługobiorca zobowiązany jest do powstrzymania się od:</li>
              <li>
                nadużywania środków komunikacji elektronicznej (np. przeciążania
                systemów Usługodawcy)
              </li>
              <li>
                prób przełamywania zabezpieczeń systemów Usługodawcy lub
                uzyskiwania nieuprawnionego dostępu
              </li>
              <li>
                działań sprzecznych z prawem, dobrymi obyczajami lub interesem
                Usługodawcy
              </li>
              <li>udostępniania danych do logowania osobom nieuprawnionym,</li>
              <li>
                dostarczania treści naruszających dobra osób trzecich, normy
                społeczne lub przepisy prawa.
              </li>
              <li>
                Usługobiorca zobowiązuje się zwolnić Usługodawcę z
                odpowiedzialności w razie roszczeń osób trzecich dotyczących
                naruszeń wskazanych w pkt 4e.
              </li>
              <li>
                Usługodawca nie ma obowiązku weryfikowania treści wprowadzanych
                przez Usługobiorców do systemu, ale po uzyskaniu wiarygodnej
                informacji o ich bezprawnym charakterze - może je usunąć i/lub
                zawiesić dostęp do usług.
              </li>
              <li>
                Zakazane są wszelkie działania lub zaniechania, które mogłyby
                zakłócać prawidłowe funkcjonowanie Serwisu (np. przeciążanie,
                zakłócanie, instalowanie złośliwego oprogramowania).
              </li>
              <li>
                Zakazane jest wprowadzanie do Serwisu wirusów, keyloggerów lub
                oprogramowania do rozsyłania SPAM-u.
              </li>
              <li>
                Usługodawca zobowiązuje się do zachowania poufności danych
                Usługobiorców, chyba że:
              </li>
              <li>
                dane są publicznie dostępne lub znane bez naruszenia prawa
              </li>
              <li>obowiązek ujawnienia wynika z przepisów prawa</li>
              <li>Usługobiorca wyraził na to zgodę.</li>
              <li>
                Usługobiorca zobowiązany jest do podawania danych zgodnych ze
                stanem faktycznym.
              </li>
              <li>
                W razie naruszenia przepisów prawa lub Regulaminu przez
                Usługobiorcę, Usługodawca może:
              </li>
              <li>zablokować dostęp do Serwisu</li>
              <li>usunąć Konto</li>
              <li>odmówić utworzenia kolejnego Konta.</li>
              <li>
                W przypadku podjęcia takich działań, Usługodawca poinformuje
                Usługobiorcę w ciągu 3 dni, przesyłając wiadomość na adres
                e-mail powiązany z Kontem.
              </li>
              <li>
                Zabronione jest dokonywanie za pośrednictwem Serwisu
                jakichkolwiek działań naruszających powszechnie obowiązujące
                przepisy prawa, w szczególności niedozwolone jest:
                <ol>
                  <li>
                    wzywanie do nienawiści rasowej, wyznaniowej lub etnicznej
                  </li>
                  <li>
                    rozpowszechnianie treści naruszających dobra osobiste osób
                    trzecich (w tym innych Użytkowników) lub zagrażających
                    naruszeniem takich dóbr osobistych
                  </li>
                  <li>
                    podejmowanie działań spełniających znamiona przestępstwa lub
                    zachęcających do popełniania przestępstw (w tym
                    zniesławienia lub pomówienia
                  </li>
                  <li>propagowanie przemocy i agresji</li>
                  <li>
                    propagowanie alkoholu, środków odurzających, narkotyków oraz
                    pornografii
                  </li>
                  <li>rozpowszechnianie treści reklamowych i promocyjnych</li>
                  <li>
                    rozpowszechnianie materiałów naruszających (bądź
                    zagrażających) prawom autorskim i pokrewnym osób trzecich
                  </li>
                  <li>
                    rozpowszechnianie materiałów naruszających lub zagrażających
                    prawom własności przemysłowej (w tym prawom z rejestracji
                    znaku towarowego lub patentu) lub innym prawom osób trzecich
                  </li>
                  <li>
                    rozpowszechnianie danych informatycznych zawierających
                    wirusy komputerowe lub inne informatyczne rozwiązania
                    niszczące
                  </li>
                  <li>
                    rozpowszechnianie treści naruszających zasady współżycia
                    społecznego
                  </li>
                  <li>
                    rozpowszechnianie wulgaryzmów, treści obraźliwych,
                    obscenicznych lub naruszających powszechnie uznawane zasady
                    etyczne i zasady kultury osobistej
                  </li>
                  <li>rozpowszechnianie spamu.</li>
                </ol>
              </li>
            </ol>
            <h5>
              <strong>Rozdział 7 - Reklamacje</strong>
            </h5>
            <ol>
              <li>
                Użytkownikowi przysługuje reklamacja w zakresie dotyczącym
                nieprawidłowego działania Serwisu.
              </li>
              <li>
                Reklamacje związane z usługami świadczonymi drogą elektroniczną
                można składać:
                <ol>
                  <li>pisemnie na adres Usługodawcy,</li>
                  <li>
                    elektronicznie na adres:
                    <a href="mailto:infoforum@isw.org.pl"
                      >infoforum@isw.org.pl</a
                    >.
                  </li>
                </ol>
              </li>
              <li>
                Reklamacja powinna być zgłoszona przez Użytkownika w terminie
                nie późniejszym niż 7 dni od daty zaistnienia nieprawidłowości w
                korzystaniu z Serwisu.
              </li>
              <li>
                Reklamacje będą rozpatrywane przez Usługodawcę lub upoważnioną
                przez niego osobę w ciągu 14 dni roboczych od dnia otrzymania
                reklamacji. W tym terminie Usługodawca poinformuje Użytkownika o
                sposobie rozpatrzenia reklamacji.
              </li>
              <li>
                W przypadku gdy reklamacja będzie zasadna Usługodawca w
                porozumieniu z Użytkownikiem albo udostępni ponownie poprawioną
                już Usługę albo w inny sposób zrekompensuje poniesioną szkodę, w
                szczególności poprzez wydłużenie okresu świadczenia Usługi o
                okres w którym Usługa nie była dostępna.
              </li>
              <li>
                Prawidłowo złożona reklamacja powinna zawierać w swej treści:
                oznaczenie Użytkownika (w szczególności imię̨ i nazwisko), adres
                poczty elektronicznej użytej podczas rejestracji w Serwisie oraz
                ewentualnie adres do korespondencji (pocztowej), a także
                dokładny opis problemu i ewentualnie okoliczności uzasadniające
                reklamację i przedmiot reklamacji.
              </li>
              <li>
                Usługodawca nie ponosi odpowiedzialności za brak dostępu do
                Usługi spowodowany okolicznościami, których nie można uniknąć
                bez istotnych, dodatkowych kosztów lub z przyczyn leżących po
                stronie osób trzecich, jak również spowodowanych działaniami
                siły wyższej. W szczególności Usługodawca nie ponosi
                odpowiedzialności za blokowanie przez administratorów serwerów
                pocztowych przesyłania wiadomości dotyczących zamówienia, w tym
                parametrów dostępowych (kod dostępu) na adres e-mail wskazany
                przez Użytkownika oraz za usuwanie i blokowanie e-maili przez
                oprogramowanie zainstalowane na komputerze używanym przez
                Użytkownika. Za złamanie postanowień niniejszego Regulaminu
                poczytuje się nieudostępnienie Usługi w ciągu 14 dni od dnia
                zgłoszenia przez Użytkownika reklamacji zawierającej informacje
                niezbędne do ustalenia przyczyn niedostępności Usługi dla
                Użytkownika.
              </li>
              <li>
                Na Usługę nie jest udzielana gwarancja. Usługodawca nie świadczy
                usług posprzedażowych.
              </li>
              <li>
                Usługodawca informuje, że istnieją możliwości skorzystania z
                pozasądowych sposobów rozpatrywania reklamacji i dochodzenia
                roszczeń. Skorzystanie z nich ma charakter dobrowolny i może
                mieć miejsce wyłącznie, gdy obie strony sporu wyrażą na to
                zgodę.
              </li>
              <li>
                Szczegółowe informacje dotyczące rozstrzygania sporów
                konsumenckich w tym możliwości skorzystania przez Użytkownika z
                pozasądowych sposobów rozpatrywania reklamacji, dochodzenia
                roszczeń oraz zasady dostępu do tych procedur dostępne są w
                siedzibach oraz na stronach internetowych wojewódzkich
                inspektoratów Inspekcji Handlowej oraz pod adresem internetowym:
                <a href="https://uokik.gov.pl/spory_konsumenckie.php"
                  >https://uokik.gov.pl/spory_konsumenckie.php</a
                >.
              </li>
            </ol>
            <h5>
              <strong
                >Rozdział 8 - Szczególne zagrożenia związane z korzystaniem z
                usługi świadczonej drogą elektroniczną</strong
              >
            </h5>
            <ol>
              <li>
                Korzystanie z usług wiąże się z ryzykiem infekcji systemu przez
                złośliwe oprogramowanie.
              </li>
              <li>
                Zaleca się zainstalowanie i regularną aktualizację programu
                antywirusowego.
              </li>
              <li>
                Zaleca się także uruchomienie zapory systemowej (firewalla).
              </li>
              <li>
                Istnieje także ryzyko ataków hakerskich - Usługodawca stosuje
                zabezpieczenia mające na celu ich uniemożliwienie lub
                utrudnienie.
              </li>
            </ol>
            <h5>
              <strong>Rozdział 9 - Prawa autorskie</strong>
            </h5>
            <ol>
              <li>
                Wszelkie prawa autorskie, znaki towarowe, domeny, logotypy,
                znaki użytkowe, tajemnice handlowe, patenty oraz inne prawa
                własności intelektualnej powiązane z Usługami Usługodawcy
                stanowią jego własność.
              </li>
              <li>
                Użytkownik nie może wykorzystywać praw autorskich, znaków
                towarowych (lub podobnych znaków), domen, logotypów, znaków
                użytkowych, tajemnic handlowych, patentów czy innych praw
                własności intelektualnej Usługodawcy, chyba że za wyraźnym
                pozwoleniem udzielonym w formie dokumentowej lub na piśmie.
              </li>
              <li>
                Na potrzeby umożliwienia dostarczania naszych Usług, użytkownik
                udziela Usługodawcy globalnej, niewyłącznej, nieodpłatnej,
                obejmującej prawo do sublicencji i przenoszenia, licencji na
                wykorzystywanie, odtwarzanie, dystrybuowanie informacji (w tym
                treści) przesyłanych, dostarczanych, przechowywanych, wysyłanych
                lub otrzymywanych w naszych Usługach lub za ich pośrednictwem,
                jak również na tworzenie na ich podstawie dzieł pochodnych oraz
                na ich wyświetlanie i wykonywanie. Prawa przyznawane na mocy
                licencji służą ograniczonemu celowi obsługi i świadczenia
                naszych Usług (np. umożliwieniu nam wyświetlenia zdjęcia
                profilowego użytkownika, komunikatu o jego statusie,
                przekazywania wiadomości i przechowywania wiadomości
                niedostarczonych na naszych serwerach).
              </li>
              <li>
                Usługodawcy udziela Użytkownikowi ograniczonej, odwołalnej,
                niewyłącznej, nieobejmującej prawa do sublicencjonowania i
                niepodlegającej przenoszeniu licencji na korzystanie z naszych
                Usług, z zastrzeżeniem zapisów naszego Regulaminu i w zgodzie z
                nim. Licencja ta służy wyłącznie do celu umożliwienia
                użytkownikowi korzystania z naszych Usług w sposób dozwolony
                Regulaminem. Użytkownik nie otrzymuje żadnych licencji ani praw,
                dorozumianych ani żadnych innych, poza licencjami i prawami
                przyznanymi mu jawnie i jednoznacznie.
              </li>
              <li>
                Użytkownik Aplikacji jest zobowiązany do przestrzegania warunków
                niniejszej licencji w zakresie treści dostępnych w ramach
                Aplikacji. Usługodawca może określić warunki licencji odrębnie,
                zamieszczając stosowny zapis w Aplikacji.
              </li>
              <li>
                Użytkownik ma prawo korzystać z Aplikacji wyłącznie na własny
                użytek, o ile inaczej nie wskazano w Aplikacji.
              </li>
              <li>
                Zabrania się Klientowi udostępniać dane do swojego Konta innym
                nieupoważnionym podmiotom.
              </li>
              <li>
                Dostępne w ramach Aplikacji usługi nie mogą być przedmiotem
                rozporządzenia przez Użytkownika (w szczególności odsprzedaży
                czy dystrybucji i sprzedaży handlowej).
              </li>
              <li>Licencja nie obejmuje prawa do:</li>
              <li>
                trwałego lub czasowego zwielokrotnienia treści dostępnych w
                ramach Aplikacji, w całości lub w części, w celu innym niż
                utworzenie kopii na własny użytek,
              </li>
              <li>
                wprowadzania jakichkolwiek innych zmian w części lub w całości
                treści, dostępnych w Aplikacji,
              </li>
              <li>
                odpłatnego lub nieodpłatnego rozpowszechniania treści,
                dostępnych w Aplikacji jakimikolwiek środkami i w jakiejkolwiek
                formie.
              </li>
              <li>
                Celem wykorzystania oznaczeń Usługodawcy lub Aplikacji należy
                uzyskać zgodę Usługodawcy.
              </li>
            </ol>
            <h5>
              <strong>Rozdział 10 - Postanowienia przejściowe i końcowe</strong>
            </h5>
            <ol>
              <li>
                Zasady przetwarzania danych osobowych w związku ze świadczeniem
                usług elektronicznych określone są w dokumencie
                <strong>Polityka prywatności</strong> dostępnym w Serwisie.
              </li>
              <li>
                Niezależnie od postanowień Regulaminu, Usługobiorca zobowiązany
                jest do stosowania się do informacji i komunikatów wysyłanych
                przez Usługodawcę, jeśli dotyczą one:
                <ol>
                  <li>zasad technicznych</li>
                  <li>bezpieczeństwa</li>
                  <li>
                    zapewnienia prawidłowości lub sprawności korzystania z
                    Serwisu.
                  </li>
                </ol>
              </li>
              <li>
                Wszelkie zmiany Regulaminu zostaną podane do wiadomości
                Usługobiorcy w jeden z dwóch sposobów:
                <ol>
                  <li>
                    poprzez wiadomość systemową, która wyświetli się przy
                    pierwszym logowaniu do Konta po wprowadzeniu zmian,
                  </li>
                  <li>
                    lub w wiadomości e-mail wysłanej na adres przypisany do
                    Konta Usługobiorcy.
                  </li>
                </ol>
              </li>
              <li>
                Niniejszy Regulamin został sporządzony na podstawie polskiego
                prawa.
              </li>
              <li>
                W przypadku pytań dotyczących Regulaminu lub zgłoszeń
                dotyczących jego naruszenia prosimy o kontakt:
                <a href="mailto:infoforum@isw.org.pl">infoforum@isw.org.pl</a>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";

import PageHeader from "./layout/PageHeader";

export default {
  components: { PageHeader },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",

  data() {
    return {
      image: require("@/assets/img/conference/landing-bg-fe26.jpg"), // header img
    };
  },
};
</script>
<style scoped>
h3 {
  text-align: center;
  margin-bottom: 60px;
  color: rgb(23, 24, 83);
}
h5 {
  text-align: center;
  margin-bottom: 30px;
  margin-top: 30px;
  color: rgb(23, 24, 83);
}
</style>
